import { Image } from '@unpic/react';
import { t } from '@transifex/native';
import { cn, getDisplayName } from '~/lib/utils';
import { getXpLevelConfig, type XpLevel } from '~/lib/xp-levels';
import { getVariantImage } from '~/components/ui/image-variant';
import type { components } from '~/api/openapi';

type UserDto = components['schemas']['UserDto'];

type UserMenuAvatarProps = {
  user: UserDto;
  xpLevel?: XpLevel | null;
  size?: 'normal' | 'large';
  className?: string;
};

export function UserMenuAvatar({ user, xpLevel, size = 'normal', className }: UserMenuAvatarProps) {
  const displayName = getDisplayName(user);
  const profileImageUrl = getVariantImage(user.profileUrl, 'profile');
  const levelConfig = xpLevel ? getXpLevelConfig(xpLevel) : null;

  return (
    <div className={cn('relative', className)}>
      <div
        className={cn(
          'shrink-0 overflow-hidden rounded-md',
          size === 'large'
            ? `
              size-12
              md:size-16
            `
            : 'size-12',
          levelConfig && 'border-[1.5px] border-solid'
        )}
        style={levelConfig ? { borderColor: levelConfig.borderColor } : undefined}
      >
        <Image
          src={profileImageUrl || '/user_icon_placeholder.svg'}
          alt={t('{displayName} profile', { displayName })}
          layout="fullWidth"
          aspectRatio={1}
          className="aspect-square size-full object-cover"
        />
      </div>
      {levelConfig ? (
        <img
          src={levelConfig.badgeSrc}
          alt=""
          className={cn(
            'absolute -right-2 -bottom-[3px]',
            size === 'large'
              ? `
                size-5
                md:size-6
              `
              : 'size-5'
          )}
          aria-hidden="true"
        />
      ) : null}
    </div>
  );
}
